export function mergeTagCategories(availableCategories, tags, allowMissingCategories = false) {
    return tags
        .map((category) => {
            const categoryDefinition = availableCategories.find((catDef) => catDef.name == category.name) ?? (allowMissingCategories ? {} : null);

            if (!categoryDefinition) return null;

            return {
                ...category,
                ...categoryDefinition,
                options:
                    category.options
                        ?.map(
                            (optionName) =>
                                categoryDefinition.options?.find((option) => option.name == optionName) ??
                                (allowMissingCategories
                                    ? {
                                          name: optionName,
                                      }
                                    : null)
                        )
                        .filter(Boolean) ?? [],
            };
        })
        .filter((cat) => cat && cat.name && cat.options?.length);
}
